import { z } from 'zod';

export const basicInfoSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name must be provided.' }),
  code: z.string().optional(),
  tokenLimit: z.number().optional(),
});

export const detailsSchema = z.object({
  issues: z
    .string()
    .trim()
    .min(1, { message: 'Issues must be provided' })
    .max(2000, { message: 'Issues are limited to 2000 characters' }),
  disputeType: z.string().max(100, 'Matter type must be 100 characters or fewer').optional(),
  userDefinedEntities: z.string().max(500, 'Entities are limited to 500 characters').optional(),
  additionalContext: z.string().max(2000, 'Additional context is limited to 2000 characters').optional(),
  timePeriod: z.string().optional(),
  disputeStatus: z.string().optional(),
});

export type BasicInfoForm = z.infer<typeof basicInfoSchema>;
export type DetailsForm = z.infer<typeof detailsSchema>;
